import * as moment from "moment";
import { Filter } from "services/models/odata/filter";
import * as momentBusinessDays from "moment-business-days";

export const removeAcentos = (palavra: string): string =>
  palavra.normalize("NFD").replace(/[\u0300-\u036f]/g, "");

export const isEmptyObject = (object) => {
  if (object) {
    return Object.keys(object).length === 0 && object.constructor === Object;
  }
  return true;
};

export const convertToUpperCase = (object: any) => {
  Object.keys(object).forEach((e) => {
    let isString: boolean;
    if (
      object[e] &&
      e != "birthplace" &&
      e != "domain" &&
      e != "hiringStatus"
    ) {
      isString = object[e].constructor.name == "String";
    }
    if (isString) {
      object[e] = object[e].toUpperCase();
    }
  });
};

const stringIsNumber = (value) => isNaN(Number(value)) === false;

// Turn enum into array
export const enumToArray = (enumme) =>
  Object.keys(enumme)
    .filter(stringIsNumber)
    .map((key) => enumme[key]);

export const capitalizeString = (value: string) =>
  value[0].toUpperCase() + value.slice(1);

export const isValidDateString = (field = "data"): boolean => {
  return moment(new Date(field)).isValid();
};

export const isValidDateValue = (field = "data"): boolean => {
  const isValidFormat = isValidDateString(field);

  if (!isValidFormat) return false;

  if (moment(new Date(field)).get("year") < 1990) return false;

  return true;
};

export const toDayFilter = (field = "data"): string => {
  const dataInicio = moment().startOf("date").format("YYYY-MM-DD");
  const dataFim = moment().endOf("date").format("YYYY-MM-DD");

  const startDate = { type: "guid", value: dataInicio };
  const endDate = { type: "guid", value: dataFim };

  const filterQuery = [{ [field]: { ge: startDate, le: endDate } }];
  return Filter.multEquals(filterQuery);
};

export const toDayTransationFilter = (): string => {
  const toDay = moment().format("YYYY/MM/DD");
  return `&inicio=${toDay}&fim=${toDay}`;
};

export const nextBusinessDayByQuantity = (quantity: number = 1): string => {
  const today = moment(Date.now()).format("DD-MM-YYYY");
  let nextDay = moment(today, "DD-MM-YYYY").add(quantity, "d");
  if (!isBusinessDay(nextDay)) {
    nextDay = nextBusinessDay(nextDay);
  }
  const result = getDayFromObjectMomentBusinessDays(nextDay);
  return result;
};

export const nextBusinessDay = (day: any): any =>
  momentBusinessDays(day, "DD-MM-YYYY").nextBusinessDay();

export const isBusinessDay = (day: any): boolean =>
  momentBusinessDays(day, "DD-MM-YYYY").isBusinessDay();

export const getDayFromObjectMomentBusinessDays = (momentBD: any): string => {
  const object = { day: momentBD._d };
  return moment(object.day, "DD/MM/YYYY").format("YYYY-MM-DD");
};

export default {
  removeAcentos,
};

export const omit_special_char = (event) => {
  const k = event.charCode;
  return (
    (k > 64 && k < 91) ||
    (k > 96 && k < 123) ||
    k == 8 ||
    k == 32 ||
    (k >= 48 && k <= 57)
  );
};

export const customPattern = {
  B: {
    pattern: new RegExp("[a-zA-Z]"),
    optional: true,
  },
};

export const customPatternWithNumbers = {
  C: {
    pattern: new RegExp("[a-zA-Z0-9]"),
    optional: true,
  },
};

export const customPatternNumbers = {
  D: {
    pattern: new RegExp('[0-9]'),
    optional: true,
  },
};

export const removeAcento = (text: string) => {
  text = text.replace(new RegExp("[ÁÀÂÃ]", "gi"), "a");
  text = text.replace(new RegExp("[ÉÈÊ]", "gi"), "e");
  text = text.replace(new RegExp("[ÍÌÎ]", "gi"), "i");
  text = text.replace(new RegExp("[ÓÒÔÕ]", "gi"), "o");
  text = text.replace(new RegExp("[ÚÙÛ]", "gi"), "u");
  text = text.replace(new RegExp("[Ç]", "gi"), "c");
  return text;
};

export const comparer = (a: any, b: any): boolean => {
  if (!a || !b) return false;
  return (a.value ?? a) === (b.value ?? b);
};

export const compareGuidValues = (a: any, b: any): boolean => {
  const left = `${a?.value ?? a ?? ""}`.trim().toLowerCase();
  const right = `${b?.value ?? b ?? ""}`.trim().toLowerCase();
  if (!left || !right) return false;
  return left === right;
};

export const isValidDate = (data: any): boolean => {
  return moment(data, "DD/MM/YYYY", true).isValid();
};

export const convertToCamelCase = (str: string): string => {
  return str
    .toLowerCase()
    .replace(/([-_][a-z])/g, (group) =>
      group.toUpperCase().replace("-", "").replace("_", "")
    );
};

export const getHourMinuteTime = (decimalHourTime: number) => {
  const intervalTimeDiffInMinutes = moment()
    .startOf("day")
    .add(decimalHourTime, "hours")
    .diff(moment().startOf("day"), "minutes");

  const intervalHours = Math.floor(intervalTimeDiffInMinutes / 60);
  const intervalMinutes = intervalTimeDiffInMinutes % 60;

  return `${intervalHours.toString().padStart(2, "0")}:${intervalMinutes
    .toString()
    .padStart(2, "0")}`;
};

export const schoolingOptions = [
  { value: 10, label: "Analfabeto" },
  { value: 20, label: "Até 4° série incompleta (primário incompleto)" },
  { value: 25, label: "4° série completa do 1° grau (primário completo)" },
  { value: 30, label: "Ensino fundamental incompleto" },
  { value: 35, label: "Ensino fundamental completo" },
  { value: 40, label: "Ensino médio incompleto" },
  { value: 45, label: "Ensino médio completo" },
  { value: 50, label: "Superior incompleto" },
  { value: 55, label: "Superior completo" },
  { value: 65, label: "Mestrado completo" },
  { value: 75, label: "Doutorado completo" },
  { value: 85, label: "Pós-graduação / Especialização" },
  { value: 95, label: "Pós-doutorado" },
];

export const months = [
  { name: "Janeiro", value: 0 },
  { name: "Fevereiro", value: 1 },
  { name: "Março", value: 2 },
  { name: "Abril", value: 3 },
  { name: "Maio", value: 4 },
  { name: "Junho", value: 5 },
  { name: "Julho", value: 6 },
  { name: "Agosto", value: 7 },
  { name: "Setembro", value: 8 },
  { name: "Outubro", value: 9 },
  { name: "Novembro", value: 10 },
  { name: "Dezembro", value: 11 },
];

export const isBoolean = (value) => {
  try {
    return typeof JSON.parse(value) === "boolean";
  } catch (e) {
    return false;
  }
};

export const isNumber = (value) => {
  try {
    return typeof JSON.parse(value) === "number";
  } catch (e) {
    return false;
  }
};

export const isNotNumber = (value) => {
  return (
    value && typeof value === "string" && isNaN(Number(value.replace(",", ".")))
  );
};

export const isNullOrEmpty = (value) => {
  return value === undefined || value == null || value === "";
};

export const getBooleanOptions = () => [
  { value: true, label: "Sim" },
  { value: false, label: "Não" },
];

export const distinct = (values: string[]) => {
  return Array.from(new Set(values));
};

export function isGuid(value: string): boolean {
  const guidRegex =
    /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;
  return guidRegex.test(value);
}

export function toGUID(guidId: string) {
  if (guidId.length !== 32) {
    throw new Error("A string deve ter exatamente 32 caracteres.");
  }
  const parts = [
    guidId.slice(0, 8),
    guidId.slice(8, 12),
    guidId.slice(12, 16),
    guidId.slice(16, 20),
    guidId.slice(20, 32),
  ];
  return parts.join("-");
}

export function toMoneyFormat(value: number) {
  return new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
  }).format(value);
}

export const guidEmpty = "00000000-0000-0000-0000-000000000000";

export function isGuidEmpty(id: unknown): boolean {
  return id == null || id === "" || id === guidEmpty;
}

export function isOvertimeOccurrenceWithoutBonusReasonId(
  usesOvertimeJustification: boolean,
  timeOccurrence: { subType?: string; bonusReasonId?: string | null }
): boolean {
  if (!usesOvertimeJustification || timeOccurrence.subType !== "OVERTIME") {
    return false;
  }
  const id = timeOccurrence.bonusReasonId;
  return id == null || id === "" || id === guidEmpty;
}

/**
 *
 * @param form form group
 * @param keys list of keys fields of forms
 * @returns boolean if some field valid
 *
 * Obs.:: mark all fields passed when touched
 */
export const validateFormFields = (form: any, keys: string[]) => {
  let hasErrors = false;

  keys.forEach((key: string) => {
    const control = form.get(key);

    if (control?.invalid) {
      control.markAllAsTouched();

      hasErrors = true;
    }
  });

  return hasErrors;
};

export function formattedPhone(value: string): string {
  if (!value) return "";

  const digits = value.replace(/\D/g, "");

  if (digits.length === 8) {
    return `${digits.slice(0, 4)}-${digits.slice(4)}`;
  } else if (digits.length === 9) {
    return `${digits.slice(0, 5)}-${digits.slice(5)}`;
  } else if (digits.length === 10) {
    return `(${digits.slice(0, 2)}) ${digits.slice(2, 6)}-${digits.slice(6)}`;
  } else if (digits.length === 11) {
    return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7)}`;
  }

  return value;
}

export const toTitleCase = (value: string): string => {
  if (!value) return "";

  const lowerCaseWords = [
    "de", "da", "do", "dos", "das",
    "e", "em", "na", "no", "nas", "nos"
  ];

  return value
    .toLowerCase()
    .split(" ")
    .map((word, index) => {
      if (index > 0 && lowerCaseWords.includes(word)) {
        return word;
      }
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join(" ");
};

export const normalize = (value: string) =>
  value.replace(/[^\w]/g, "").toLowerCase();

export const sexagesimalToMinutes = (value: number): number => {
  const hours = Math.floor(value);
  const minutes = Math.round((value - hours) * 100);
  return hours * 60 + minutes;
}

export const minutesToSexagesimal = (minutes: number): number => {
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  return parseFloat(`${hours}.${mins.toString().padStart(2, '0')}`);
}

export function cleanObject(obj: any): any {
  const cleaned: any = {};
  Object.keys(obj).forEach((key) => {
    const value = obj[key];

    if (Array.isArray(value)) {
      if (value.length > 0) {
        cleaned[key] = value;
      }
    } else if (value !== null && value !== undefined && value !== "") {
      cleaned[key] = value;
    }
  });

  return cleaned;
}

export function flattenObject(ob: any, prefix = "", options?: { dateOnly?: boolean }): any {
  let result: any = {};
  for (const key in ob) {
    if (!ob.hasOwnProperty(key)) continue;

    const value = ob[key];
    const prefixedKey = prefix ? `${prefix}.${key}` : key;

    if (value instanceof Date) {
      result[prefixedKey] = options?.dateOnly
        ? toDateOnly(value)
        : value.toISOString();
      continue;
    }

    if (
      typeof value === "string" &&
      /^\d{4}-\d{2}-\d{2}$/.test(value)
    ) {
      result[prefixedKey] = value;
      continue;
    }

    if (
      typeof value === "string" &&
      !isNaN(Date.parse(value))
    ) {
      const date = new Date(value);
      result[prefixedKey] = options?.dateOnly
        ? toDateOnly(date)
        : date.toISOString();
      continue;
    }

    if (
      typeof value === "object" &&
      value !== null &&
      !Array.isArray(value)
    ) {
      result = { ...result, ...flattenObject(value, prefixedKey, options) };
    } else {
      result[prefixedKey] = value;
    }
  }
  return result;
}

export function getTenantPrefix(): string {
  const path = window.location.pathname;
  const segments = path.split('/');
  return segments.length > 1 ? `/${segments[1]}` : '';
}

/**
 * Remove o prefixo de uma URL
 * Ex: "/gruposantana/hiring/applicants" => "/hiring/applicants"
 */
export function normalizeUrl(url: string): string {
  const prefix = getTenantPrefix();
  return url.startsWith(prefix) ? url.substring(prefix.length) : url;
}


function toDateOnly(date: Date): string {
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const day = date.getDate().toString().padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export function formatDecimal(value: number, decimalPlaces: number): string {
  let result = value.toFixed(decimalPlaces);
  result = result.replace(/\.?0+$/, "");
  return result.replace(".", ",");
}

export function toShortFormat(value: number, decimalPlaces: number = 2): string {
  if (!value) return "0";

  const abs = Math.abs(value);

  // Menor que 1000 → formato normal
  if (abs < 1000) {
    return formatDecimal(value, decimalPlaces);
  }

  const suffixes: Array<{ value: number; suffix: string }> = [
    { value: 1_000_000_000_000, suffix: "T" }, // trilhão
    { value: 1_000_000_000, suffix: "B" },     // bilhão
    { value: 1_000_000, suffix: "M" },         // milhão
    { value: 1_000, suffix: "K" }              // mil
  ];

  for (const s of suffixes) {
    if (abs >= s.value) {
      const reduced = value / s.value;
      let result = reduced.toFixed(decimalPlaces);

      // remove zeros à direita
      result = result.replace(/\.?0+$/, "");

      // troca separador
      result = result.replace(".", ",");

      // garante pelo menos 1 casa decimal
      if (!result.includes(",")) {
        result += ",0";
      }

      return `${result}${s.suffix}`;
    }
  }

  return formatDecimal(value, 0);
}

export const formatToPtBrDate = (
  value?: string | Date | null,
  withTime: boolean = false
): string => {
  if (!value) return '';

  const m = moment(value);

  if (!m.isValid()) return '';

  return withTime
    ? m.format('DD/MM/YYYY HH:mm:ss')
    : m.format('DD/MM/YYYY');
};

export function parseDateOnly(value?: string | Date | null): string {
  if (!value) return '';

  const date = value instanceof Date ? value : new Date(value);
  return toDateOnly(date);
}

/**
 * Normaliza uma data para formato ISO (YYYY-MM-DD).
 * Aceita Date, string ISO ou string pt-BR (DD/MM/YYYY).
 */
export function normalizeDate(date?: string | Date | null): string | null {
  if (!date) {
    return null;
  }

  if (date instanceof Date) {
    if (isNaN(date.getTime())) {
      return null;
    }
    return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()))
      .toISOString()
      .split('T')[0];
  }

  if (typeof date === 'string') {
    const isoMatch = date.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (isoMatch) {
      // 200001-01-01 não casa com \d{4}-; reforço para strings ambíguas.
      if (/^\d{5,}-/.test(date)) {
        return null;
      }
      const [, yyyy, mm, dd] = isoMatch;
      return new Date(Date.UTC(parseInt(yyyy, 10), parseInt(mm, 10) - 1, parseInt(dd, 10)))
        .toISOString()
        .split('T')[0];
    }

    const slashMatch = date.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
    if (slashMatch) {
      const [, dd, mm, yyyy] = slashMatch;
      return new Date(Date.UTC(parseInt(yyyy, 10), parseInt(mm, 10) - 1, parseInt(dd, 10)))
        .toISOString()
        .split('T')[0];
    }

    if (date.includes('T')) {
      return date.split('T')[0];
    }
  }

  return null;
}

/**
 * Faixa de anos aceita em filtros de período (RH / indicadores).
 * Ano com 4 dígitos; evita valores como 200026 que o Date do JS ainda aceita.
 */
export const PERIOD_FILTER_YEAR_MIN = 1900;

export function getPeriodFilterYearMax(): number {
  return new Date().getFullYear() + 1;
}

export function getPeriodFilterMinDate(): string {
  return `${PERIOD_FILTER_YEAR_MIN}-01-01`;
}

export function getPeriodFilterMaxDate(): string {
  return `${getPeriodFilterYearMax()}-12-31`;
}

/**
 * min/max do input type="date" para o Chrome limitar o ano a 4 dígitos (0000–9999),
 * independentemente de digitar o ano no início ou no fim.
 */
export const HTML_DATE_YEAR_DIGIT_MIN = "0000-01-01";
export const HTML_DATE_YEAR_DIGIT_MAX = "9999-12-31";

/**
 * Se o value do type="date" vier com ano > 4 dígitos, trunca para 4.
 */
export function limitHtmlDateInputYear(event: Event): string | null {
  const input = event.target as HTMLInputElement | null;
  if (!input) {
    return null;
  }

  const value = input.value ?? "";
  if (!value) {
    return value;
  }

  const parts = value.split("-");
  const year = parts[0] ?? "";
  if (year.length <= 4) {
    return value;
  }

  parts[0] = year.slice(0, 4);
  const limited = parts.join("-");
  input.value = limited;
  return limited;
}

const PERIOD_FILTER_ISO_DATE = /^(\d{4})-(\d{2})-(\d{2})$/;

/** Retorna mensagem de erro da data, ou null se válida. */
function getPeriodFilterDateError(value: string): string | null {
  const match = value.match(PERIOD_FILTER_ISO_DATE);
  if (!match) {
    return "Datas inválidas.";
  }

  const year = Number(match[1]);
  const yearMax = getPeriodFilterYearMax();
  if (year < PERIOD_FILTER_YEAR_MIN || year > yearMax) {
    return `Informe um ano entre ${PERIOD_FILTER_YEAR_MIN} e ${yearMax}.`;
  }

  const date = new Date(`${value}T00:00:00.000Z`);
  if (isNaN(date.getTime())) {
    return "Datas inválidas.";
  }

  const [, yyyy, mm, dd] = match;
  const isSameCalendarDay =
    date.getUTCFullYear() === Number(yyyy) &&
    date.getUTCMonth() + 1 === Number(mm) &&
    date.getUTCDate() === Number(dd);

  return isSameCalendarDay ? null : "Datas inválidas.";
}

/**
 * Valida um intervalo de datas de filtro.
 * - Ambos vazios: válido (salvo se requireBoth).
 * - Apenas um preenchido: inválido.
 * - Ambos preenchidos: formato ISO, ano na faixa permitida e início <= fim.
 */
export function validatePeriodRange(
  begin: string | null | undefined,
  end: string | null | undefined,
  options?: { requireBoth?: boolean }
): string | null {
  const hasBegin = !!begin;
  const hasEnd = !!end;

  if (!hasBegin && !hasEnd) {
    return options?.requireBoth ? "Informe a data inicial e a data final." : null;
  }

  if (!hasBegin || !hasEnd) {
    return "Informe a data inicial e a data final.";
  }

  const beginError = getPeriodFilterDateError(begin as string);
  if (beginError) {
    return beginError;
  }

  const endError = getPeriodFilterDateError(end as string);
  if (endError) {
    return endError;
  }

  const beginDate = new Date(`${begin as string}T00:00:00.000Z`);
  const endDate = new Date(`${end as string}T00:00:00.000Z`);

  if (beginDate > endDate) {
    return "A data inicial deve ser anterior à data final.";
  }

  return null;
}

export function getApiErrorMessage(error: any, fallback: string): string {
  const message =
    error?.error?.message ||
    error?.error?.title ||
    error?.error?.detail ||
    error?.message;

  return typeof message === "string" && message.trim() ? message.trim() : fallback;
}

export function getTodayIsoDate(): string {
  return normalizeDate(new Date()) || "";
}
